import type { SxProps, Theme } from "@mui/material";

/** White-filled, rounded input styling shared across broadcast form sections. */
export const fieldSx = (theme: { shape: { borderRadiusMd: number } }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "common.white",
    borderRadius: `${theme.shape.borderRadiusMd}px`,
  },
});

/** Outer titled-section wrapper (elevation-0 backdrop). */
export const sectionOuterSx: SxProps<Theme> = {
  gap: 2,
  backgroundColor: (theme) => theme.palette.background["paper-elevation-0"],
  borderRadius: (theme) => `${theme.shape.borderRadiusMd}px`,
  p: 6,
};

/** Inner content card (elevation-1) nested inside a titled section. */
export const sectionInnerSx = (theme: Theme) => ({
  backgroundColor: theme.palette.background["paper-elevation-1"],
  borderRadius: `${theme.shape.borderRadiusMd}px`,
  p: 6,
});
